import api from "../../../../service/api"

const rootUrl = 'tms/batches/bca-attendance'

export const getData = (id = null) => api.get(`${rootUrl}/list/${id}`)
export const getStudent = (id = null) => api.get(`${rootUrl}/create/${id}`)
export const generatePdf = (id = null) => api.getpdf(`${rootUrl}/generate-pdf/${id}`)


